export default __webpack_public_path__ + "static/media/users.7f2144f5.svg";